import { MiniFlexTable } from "@similarweb/ui-components";
import type { IMiniFlexTableProps } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledMiniFlexTable = styled(MiniFlexTable)<IMiniFlexTableProps>`
    & .MiniFlexTable-container {
        display: flex;
        flex-direction: row;
        column-gap: 24px;
    }

    & .MiniFlexTable-column {
        flex-grow: 0 !important;
    }

    & .MiniFlexTable-headerCell {
        margin: 0 0 16px 0;
    }

    & .MiniFlexTable-cell {
        display: flex;
        align-items: center;

        margin: 8px 0;
        height: 26px;
        line-height: 26px;

        box-sizing: border-box;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;
